import * as api from "../API/index";

// Dashboard Job Status Count
export const dashboardJobStatusCount = async (params) => {
  try {
    const res = await api.get_dashboard_job_status_count(params);
    return res;
  } catch (error) {
    return error?.response?.data || error;
  }
};

// Dashboard Payment Status Count
export const dashboardPaymentStatusCount = async (params) => {
  try {
    const res = await api.get_dashboard_payment_status_count(params);
    return res;
  } catch (error) {
    return error?.response?.data || error;
  }
};

// Dashboard Quotation Status Count
export const dashboardQuotationStatusCount = async (params) => {
  try {
    const res = await api.get_dashboard_quotation_status_count(params);
    return res;
  } catch (error) {
    return error?.response?.data || error;
  }
};


// Dashboard Spare Parts Status Count
export const dashboardSparePartsStatusCount = async (params) => {
  try {
    const res = await api.get_dashboard_spare_parts_status_count(params);
    return res;
  } catch (error) {
    return error?.response?.data || error;
  }
};


// Dashboard Quotation Requested For Approval
export const dashboardQuotationRequestedForApproval = async (params) => {
  try {
    const res = await api.get_dashboard_quotation_requested_for_approval(params);
    return res;
  } catch (error) {
    return error?.response?.data || error;
  }
};

// Dashboard Spare Parts Ready for Pickup Count
export const dashboardSparePartsReadyForPickup = async (params) => {
  try {
    const res = await api.get_dashboard_spare_parts_ready_for_pickup(params);
    return res;
  } catch (error) {
    return error?.response?.data || error;
  }
};

// Dashboard Odoo Sync Summary
export const dashboardOdooSyncSummary = async () => {
  try {
    const res = await api.get_dashboard_odoo_sync_summary();
    return res;
  } catch (error) {
    return error?.response?.data || error;
  }
};

// Dashboard Work Order Line Chart
export const dashboardWorkOrderLineChart = async (params) => {
  try {
    const res = await api.get_dashboard_work_order_line_chart_data(params);
    return res;
  } catch (error) {
    return error?.response?.data || error;
  }
};

// Dashboard Action Required
export const dashboardActionRequired = async () => {
  try {
    const res = await api.get_dashboard_action_required();
    return res;
  } catch (error) {
    return error?.response?.data || error;
  }
};

/// Dashboard Odoo Customers Not Synced List
export const dashboardOdooCustomerNotSyncedList = async ({
  pageNum,
  searchString,
  filters,
}) => {
  try {
    const res = await api.get_dashboard_customers_not_synced_data(
      pageNum,
      searchString,
      filters,
    );
    return res;
  } catch (error) {
    return error?.response?.data || error;
  }
};

// Dashboard Odoo Manufacturers Not Synced List
export const dashboardOdooManufacturerNotSyncedList = async ({
  pageNum,
  searchString,
  filters,
}) => {
  try {
    const res = await api.get_dashboard_manufacturar_not_synced_data(
      pageNum,
      searchString,
      filters,
    );
    return res;
  } catch (error) {
    return error?.response?.data || error;
  }
};

// Dashboard Odoo Spare Parts Not Synced List
export const dashboardOdooSparePartsNotSyncedList = async ({
  pageNum,
  searchString,
  filters,
}) => {
  try {
    const res = await api.get_dashboard_spareParts_not_synced_data(
      pageNum,
      searchString,
      filters,
    );
    return res;
  } catch (error) {
    return error?.response?.data || error;
  }
};

// Dashboard Odoo Services Not Synced List
export const dashboardOdooServicesNotSyncedList = async ({
  pageNum,
  searchString,
  filters,
}) => {
  try {
    const res = await api.get_dashboard_services_not_synced_data(
      pageNum,
      searchString,
      filters,
    );
    return res;
  } catch (error) {
    return error?.response?.data || error;
  }
};

// Dashboard Odoo Quotations Not Synced List
export const dashboardOdooQuotationsNotSyncedList = async ({
  pageNum,
  searchString,
  filters,
}) => {
  try {
    const res = await api.get_dashboard_quotations_not_synced_data(
      pageNum,
      searchString,
      filters,
    );
    return res;
  } catch (error) {
    return error?.response?.data || error;
  }
};


// Dashboard action required name
export const dashboardActionRequiredList = async ({
  pageNum,
  searchString,
  filters,
}) => {
  try {
    const res = await api.get_dashboard_action_required_list_data(
      pageNum,
      searchString,
      filters,
    );
    return res;
  } catch (error) {
    return error?.response?.data || error;
  }
};

// Dashboard payment list 
export const dashboardPaymentFailedAndSuccessList = async ({
  pageNum,
  searchString,
  filters,
}) => {
  try {
    const res = await api.get_dashboard_payment_status_failed_and_success_list_data(
      pageNum,
      searchString,
      filters,
    );
    return res;
  } catch (error) {
    return error?.response?.data || error;
  }
};

export const downloadCsv = async (params) => {
  try {
    const res = await api.export_csv(params);
    return res;
  } catch (error) {
    return error?.response?.data || error;
  }
};

export const odooSalesCount = async (params) => {
  try {
    const res = await api.odoo_sales(params);
    return res;
  } catch (error) {
    return error?.response?.data || error;
  }
};

export const odooQuotationCount = async (params) => {
  try {
    const res = await api.odoo_quotation_count(params);
    return res;
  } catch (error) {
    return error?.response?.data || error;
  }
};

// Dashboard Payment Status Count
export const exportPaymentList = async () => {
  try {
    const res = await api.export_payment_list();
    return res;
  } catch (error) {
    return error?.response?.data || error;
  }
};
